import { LeanFormSchema } from '../types/config-form.types';

export const INPUT_MODE_FORM: LeanFormSchema = {
  version: '2.0.0',
  id: 'input-mode-settings',
  name: 'InputMode',
  sections: [{
    id: 'input-mode',
    labelKey: 'inputModeSettings',
    registerTable: 'V3InputModeChannels',
    customContent: 'inputModeChannel',
    fields: [],
  }],
};
